<template>
	<div class="col-12 col-sm-6 col-lg-3 mb-4 mb-lg-0">
		<div v-if="level % 5 == 0">
			<label>Ability Increases</label>
			<div class="input-group" v-for="(increase, ability) in increases" :key="`increases-${level}-${ability}`">
				<div class="input-group-prepend">
					<span class="input-group-text" style="width: 7em;">{{ability}}</span>
				</div>
				<input type="number" class="form-control" v-model.number="increases[ability]" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'level',
	],
	computed: {
		increases: function() {
			return this.$store.state.Character.Levels[this.level].AbilityIncreases
		},
	},
	watch: {
		increases: {
			deep: true,
			handler: function(value){
				this.$store.commit('setCharacterProp',[
					{
						key: `Levels[${this.level}].AbilityIncreases`,
						val: value,
					}
				])
			}
		}
	}
}
</script>

<style scoped>

</style>